import Model from 'mixins/model';
import UserModel from 'models/UserModel';

export default class CommentModel extends Model {
    constructor() {
        super();
    }
    vote({ likesCount, isLikedByUser }) {
        this.set('likesCount', likesCount);
        this.set('isLikedByUser', isLikedByUser);

        this.fireEvent('liked');
    }
    update(model) {
      Object.keys(model.properties).forEach((key) => {
        this.properties[key] = model.get(key);
      });
    }
    report() {
        const isFlaggedByUser = this.get('isFlaggedByUser');
        this.set('isFlaggedByUser', !isFlaggedByUser);
        this.fireEvent('flaged');
    }
    delete({ isDeleted, showAsDeleted }) {
        this.set('isDeleted', isDeleted);
        this.set('showAsDeleted', showAsDeleted);
        this.fireEvent('deleted');
    }
    focus() {
        this.fireEvent('focused');
    }
    static fromJSON(data) {
        const {
            id,
            parentCommentId,
            replies,
            User,
            EditHistory,
            textContent,
            isRecommended,
            isLikedByUser,
            isUserBanned,
            isDeleted,
            isShadow,
            commentUrl,
            articleUrl,
            articleTitle,
            showAsDeleted,
            isNew,
            likesCount,
            url,
            isFlaggedByUser,
            createdAt,
            lastModifiedAt,
            banInfo,
        } = data;
        const commentModel = new CommentModel();

        commentModel.set('id', parseInt(id));
        commentModel.set('parentCommentId', (parentCommentId !== null) ? parseInt(parentCommentId): null);

        if (replies) {
          const repliesModels = [];

          replies.forEach((reply) => {
            const commentModel = CommentModel.fromJSON(reply);
            repliesModels.push(commentModel);
          });

          commentModel.set('replies', repliesModels);
        } else {
          commentModel.set('replies', []);
        }

        commentModel.set('User', UserModel.fromJSON(User));
        commentModel.set('EditHistory', EditHistory || []);
        commentModel.set('textContent', textContent);
        commentModel.set('isRecommended', Boolean(isRecommended));
        commentModel.set('isNew', Boolean(isNew));
        commentModel.set('isLikedByUser', Boolean(isLikedByUser));
        commentModel.set('isUserBanned', Boolean(isUserBanned));
        commentModel.set('isDeleted', Boolean(isDeleted));
        commentModel.set('isShadow', Boolean(isShadow));
        commentModel.set('commentUrl', commentUrl);
        commentModel.set('articleUrl', articleUrl);
        commentModel.set('articleTitle', articleTitle);
        commentModel.set('showAsDeleted', Boolean(showAsDeleted));
        commentModel.set('isFlaggedByUser', Boolean(isFlaggedByUser));
        commentModel.set('likesCount', parseInt(likesCount));
        commentModel.set('url', url);
        commentModel.set('createdAt', createdAt);
        commentModel.set('banInfo', banInfo);

        return commentModel;
    }
    static isMessageCorrect(message) {
        return (message !== '') && (message.replace(/\s/g, '').length);
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/CommentModel.js